const E = {
  FULL_NAME: "fullName",
  EMAIL: "email",
  MOBILE_NUMBR: "mobileNumber",
  ROUTE: "route",
  CUSTOM_ROUTE: "custom_route",
  PLAN_INFO: "planInformation",
  PREFERRED_BUS_TYPE: "preferredBusType",
  MESSAGE: "message"
}, e = {
  RESERVATION_FORM_LOCAL: "https://script.google.com/macros/s/AKfycbwdZH8DW7DagXQaF9Z1hy6oR6WAgb93E6-dgI3JTPcQQkVDzscc14-dwoziH9f8m5uUzg/exec",
  RESERVATION_FORM_PROD: "https://script.google.com/macros/s/AKfycbyxCQ6EGnNm8V8wmENCxTgiokhwv6GelqGNgRptBNq-PTYwrJNHZTAcVDTa3XKO0dag/exec"
}, o = {
  LUXURY: "Luxury",
  SEMI_LUXURY: "Semi_Luxury",
  REGULAR: "Regular"
}, R = 0;
export {
  o as BUS_TYPE,
  R as CUSTOMER_DEFAULT_RATING,
  E as FIELD_NAME,
  e as GOOGLE_SHEETS
};
